export const constantTypes = {
  authPage: [
    "/login",
    "/verify-otp",
    "/forgot-password",
    "/reset-password",
    "/book-a-demo",
    "/",
    "/verify-card",
  ],
  familyInformation: {
    relationWith: "",
    firstName: "",
    lastName: "",
    dob: "",
    mobile: "",
    designation: "",
    department: "",
    education: "",
    maritalStatus: "",
  },
};
